import { FC } from 'react';
import { ImagesService } from 'service/images/imagesService';

interface CardCarouselBackgroundMaskProps {
  componentName: string;
  backgroundImage: string;
}

export const CardCarouselBackgroundMask: FC<CardCarouselBackgroundMaskProps> = ({
  componentName,
  backgroundImage,
}) => (
  <svg
    viewBox="0 0 1440 473"
    height="100%"
    width="100%"
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    preserveAspectRatio="none"
  >
    <defs>
      <clipPath id={`${componentName}-mask-desktop`}>
        <path d="M0.5 425.631V47.369C0.638282 47.3493 0.809842 47.3249 1.01441 47.2959C1.64085 47.2072 2.57679 47.0755 3.81436 46.9037C6.28951 46.56 9.97118 46.056 14.7964 45.4144C24.4468 44.1313 38.6712 42.2981 56.9659 40.0983C93.5554 35.6986 146.425 29.8322 211.545 23.9657C341.785 12.2328 521.019 0.5 717 0.5C912.981 0.5 1093.72 12.2328 1225.46 23.9658C1291.33 29.8322 1344.95 35.6987 1382.1 40.0984C1400.67 42.2982 1415.13 44.1314 1424.95 45.4145C1429.85 46.0561 1433.6 46.5602 1436.12 46.9038C1437.38 47.0756 1438.33 47.2074 1438.97 47.2961C1439.18 47.3255 1439.36 47.3503 1439.5 47.3701V425.63C1439.36 425.65 1439.18 425.674 1438.97 425.704C1438.33 425.793 1437.38 425.924 1436.12 426.096C1433.6 426.44 1429.85 426.944 1424.95 427.585C1415.13 428.869 1400.67 430.702 1382.1 432.902C1344.95 437.301 1291.33 443.168 1225.46 449.034C1093.72 460.767 912.981 472.5 717 472.5C521.019 472.5 341.785 460.767 211.545 449.034C146.425 443.168 93.5554 437.301 56.9659 432.902C38.6712 430.702 24.4468 428.869 14.7964 427.586C9.97118 426.944 6.28951 426.44 3.81436 426.096C2.57679 425.925 1.64085 425.793 1.01441 425.704C0.809842 425.675 0.638282 425.651 0.5 425.631Z" />
      </clipPath>
    </defs>
    <image
      height="473"
      width="1440"
      preserveAspectRatio="xMidYMid slice"
      xlinkHref={ImagesService.getImageUrlWithCompressionParams(backgroundImage ?? '', 70, 1440)}
      clipPath={`url(#${componentName}-mask-desktop)`}
    />
  </svg>
);
